var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-one"},[_c('div',{ref:"oneTxt",staticClass:"txt animate__animated",class:[_vm.isOn==0?'animate__fadeInUp':'']},[_c('img',{attrs:{"src":require("../../../../assets/img/home/one_txt.png"),"alt":"云昇新控官网"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }